"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orcaEndpointMapping = exports.unicornEndpointMapping = exports.endpointMapping = void 0;
exports.endpointMapping = {
    prod: {
        apiKey: '6KhSE2GsIV4pQXM7ACYmPaNtCkQLGVWq8em2twBF',
        endpoint: 'https://iris.cruise-api.aida.de',
    },
    test: {
        apiKey: 'Z047aaiv2O6MkPRfKBV81a24gviIAnJi2VcYrCwx',
        endpoint: 'https://test-iris.cruise-api.aida.de',
    },
};
exports.unicornEndpointMapping = {
    prod: {
        apiKey: 'watwDP0sbk19dodcGGNQnnYwXZOFxEMnKpOcFJ1A',
        endpoint: 'https://aida.de/api',
    },
    test: {
        apiKey: 'watwDP0sbk19dodcGGNQnnYwXZOFxEMnKpOcFJ1A',
        endpoint: 'https://test-www2.aida.de/api',
    },
};
exports.orcaEndpointMapping = {
    prod: {
        apiKey: 'Basic YmVhOkc3dktEWm1HOE5tUGMwUEJ2MlJ3dFh1Y3U4UUh6cjdiamZCUm55M1hoSUhTbjNjbFBtQW5EejFGT3UwTVZWdk0=',
        endpoint: 'https://aida.de/api',
    },
    test: {
        apiKey: 'Basic YmVhOkc3dktEWm1HOE5tUGMwUEJ2MlJ3dFh1Y3U4UUh6cjdiamZCUm55M1hoSUhTbjNjbFBtQW5EejFGT3UwTVZWdk0=',
        endpoint: 'https://stage.aida.de/api',
    },
};
//# sourceMappingURL=client.js.map